<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MatrAddMain from "@/views/PurcManagement/MatrManage/TabChild/MatrAddMain";

export default {
  name: "MatrAdd",
  components: {
    childTab1: MatrAddMain
  },
  data() {
    return {
      activeName: "first",
    }
  },
}
</script>

<style scoped>

</style>